import Cookies from 'js-cookie';

export const getPrivacyBannerFromURL = (): boolean => {
    if (typeof window === 'undefined') return false;

    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('privacy_banner') === 'show';
};

export const getShouldShowPrivacyBanner = (): boolean => {
    const shouldShowFromURL = getPrivacyBannerFromURL();

    const cookie = Cookies.get('tcm');
    let alreadyConfirmed = false;

    if (cookie) {
        try {
            const parsed = JSON.parse(cookie);
            alreadyConfirmed = !!parsed.confirmed;
        } catch (e) {
            alreadyConfirmed = false;
        }
    }

    return shouldShowFromURL && !alreadyConfirmed;
};
